// Local public assets respect the application's deployment base URL.
export const assetUrl = path => /^(https?:)?\/\//.test(path)
  ? path
  : `${process.env.PUBLIC_URL || ''}/${path.replace(/^\/+/, '')}`;
